import ScrollButton from "../../components/ScrollButton";
import { useEffect } from "react";

const Research = () => {
  useEffect(() => {
    document.title = "Research | Zoe-Alanah Robert";
  });
  return (
    <article className="about-main">
      <section>
        <h2 className="title-font pink-text">Research</h2>
        <ul className="cv-list">
          <li><a href="https://arxiv.org/abs/1905.02196" target="_blank" rel="noopener noreferrer"><i>Mapping Missing Populations in Rural India: A Deep Learning Approach With Satelite Imagery</i></a> (2018)</li>
          <li><a href="https://cs230.stanford.edu/projects_spring_2018/reports/8289680.pdf" target="_blank" rel="noopener noreferrer"><i>Deep Learning & the Opioid Epidemic: Estimating Opioid-Related Mortality Risk in US Counties with Twitter Data</i></a> (2018)</li>
          <li><a href="http://cs231n.stanford.edu/reports/2017/pdfs/227.pdf" target="_blank" rel="noopener noreferrer"><i>Lip Reading Word Classification</i></a> (2017)</li>
          <li><a href="https://cs229.stanford.edu/proj2016/report/ShroffLimonchikRobert-PredictingImaginedMetersInMusicalPattersFromMEGData-report.pdf" target="_blank" rel="noopener noreferrer"><i>Predicting Imagined Meters in Musical Patterns from MEG Data</i></a> (2016)</li>
        </ul>
        <p className="gray-text">After publishing my satelite research in the AI, Ethics, and Society sub-conference of <a href="https://aaai.org/" target="_blank" rel="noopener noreferrer">AAAI</a>, I also served as a program committee member for a number of years reviewing journal publication applications.</p>
      </section>
      <ScrollButton />
    </article>
  );
};

export default Research;
